import React from "react";
import { ReactSortable } from "react-sortablejs";
import "./AiModelSelector.css";

const ALL_MODELS = ["openai", "gemini", "attestr"];

const AI_MODEL_LABELS = {
  openai: "OpenAI",
  gemini: "Gemini",
  attestr: "Attestr AI"
};

const AiModelSelector = ({ aiModels = [], setAiModels }) => {
  const selectedModelObjects = aiModels.map((id) => ({ id }));
  const unselectedModels = ALL_MODELS.filter((model) => !aiModels.includes(model));

  const handleAdd = (model) => {
    if (!aiModels.includes(model)) {
      setAiModels([model, ...aiModels]);
    }
  };

  const handleDelete = (modelId) => {
    setAiModels(aiModels.filter((m) => m !== modelId));
  };

  return (
    <div className="ai_model_selector_wrapper">
      <div className={"mb_1 font_weight_medium"}>AI Models</div>
      <div className="ai_model_selector_chips_row">
        <ReactSortable
          list={selectedModelObjects}
          setList={(newList) => setAiModels(newList.map((item) => item.id))}
          animation={200}
          className="ai_model_selector_sortable_container"
        >
          {selectedModelObjects.map((item) => (
            <div key={item.id} className="ai_model_selector_chip ai_model_selector_selected_chip">
              <span className="ai_model_selector_drag_handle">☰</span>
              {AI_MODEL_LABELS[item.id] || item.id}
              <button className="ai_model_selector_delete_btn" onClick={() => handleDelete(item.id)}>
                ✕
              </button>
            </div>
          ))}
        </ReactSortable>

        {unselectedModels.map((model) => (
          <button
            key={model}
            className="ai_model_selector_chip ai_model_selector_unselected_chip"
            onClick={() => handleAdd(model)}
          >
            {AI_MODEL_LABELS[model] || model}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AiModelSelector;
